import axios from "axios";
import axiosHttp from "helper/AxiosHttp";
import { API_URL, TOKEN_KEY } from "helper/Constants";
import { ENCRYPTION_OF_DATA } from "helper/Functions";
import Cookies from "js-cookie";

// let baseURL = API_URL + "/api";
// let token = Cookies.get(TOKEN_KEY);

class GameService {
  constructor(baseURL) {
    //console.log("GAME BASE URL : ", baseURL)
    this.api = axios.create({
        baseURL: baseURL ? `${baseURL}/api` : `${API_URL}/api`,
    });
    this.lastModified = null; 
    // Add an interceptor to handle token refresh
    this.api.interceptors.request.use(
      async(config) => {
        const token = Cookies.get("token");
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }

        if (!config.url.startsWith("http")) {
        config.baseURL = config.url.startsWith("/getProviders") 
          ? baseURL // No `/api`
          : `${baseURL || API_URL}/api`; // Default `/api`
        }
         if (config.data) {
                   config.headers["Content-Type"] = `application/json`;
                   config.data = await ENCRYPTION_OF_DATA(config.data);// Send the entire encrypted object
         }
       // console.log(config, 'Request baseURL'); // Debugging
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add a response interceptor to handle token refresh
    this.api.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;
        if (error.response && (error.response.status === 401 && error.response.data.message !== "Invalid refresh token")) {
          try {
            const newToken = await this.refreshToken();
            if (newToken) {
              // Update the token in the request header
              originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              return axios(originalRequest);
            }
          } catch (refreshError) {
            window?.location?.reload()
            return Promise.reject(refreshError);
          }
          
        }

        return Promise.reject(error);
      }
    );
  }
  async refreshToken() {
    try {
      const response = await this.api.post(
        "/auth/refresh-token",
        {},
        {
          withCredentials: true, // Optional: Use this if you still want to send cookies
        }
      );
      const newAccessToken = response.data.accessToken;
      Cookies.set("token", newAccessToken, {
        secure: true, // Only transmit over HTTPS in production
        sameSite: "None", // Required for cross-origin
      }); // Save the new token
      return newAccessToken;
    } catch (error) {
      Cookies.remove("user", { secure: true, sameSite: "None" });
      Cookies.remove("token", { secure: true, sameSite: "None" });
      Cookies.remove("refreshToken", { secure: true, sameSite: "None" });
      window?.location?.reload()
      console.error("Failed to refresh token:", error);
      return null;
    }
  }


async extractDirectGameUrl  (wrappedUrl)  {
  try {
    const urlObj = new URL(wrappedUrl);
    const innerUrl = urlObj.searchParams.get("url");
    if (!innerUrl) {
      console.warn("No 'url' parameter found in wrapped URL. Using original URL.");
    }
    return innerUrl ? decodeURIComponent(innerUrl) : wrappedUrl;
  } catch (error) {
    console.error("Error extracting direct game URL:", error);
    return wrappedUrl;
  }
};

async fetchGamesProvider  ()  {
  try {
    const response = await this.api.get(`/getProviders/getProviders`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data || [];
  } catch (error) {
    console.error("Error fetching games:", error.response || error);
    throw new Error("Failed to fetch games.");
  }
};

  async fetchGameUrl(gameId, username, key) {
    if (!username) {
      throw new Error("Username is required to launch the game.");
    }

    try {
      const playForFun = key === "demo"; // Set play_for_fun to true for demo

      const payload = {
        gameid: Number(gameId),
        play_for_fun: playForFun,
        lang: "en",
        homeurl: "https://3ak3ek.com",
        cashierurl: "https://3ak3ek.com",
      };

      const response = await this.api.post(`/get-game`, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true, // Ensure cookies or auth tokens are sent
      });

      if (response.data?.data?.gameUrl) {
        return response.data.data.gameUrl;
      } else {
        throw new Error("Game URL missing in response!");
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to fetch game URL.");
    }
  }


async fetchGames  (offset = 0, limit = 30, filters = {})  {
  try {
    let response;
    response = await this.api.get(`/gamesLocal`, {
      params: { offset, limit, ...filters },
      headers: { "Content-Type": "application/json" },
    });
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching games from database:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};

async fetchGamesByIds  (gameIds = []) {
  try {
    if (!Array.isArray(gameIds) || gameIds.length === 0) {
      throw new Error("Game IDs must be a non-empty array.");
    }

    const response = await this.api.post(
      `/getgamebyid`,
      { gameIds },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response?.data?.data || []; // Return the fetched games or an empty array
  } catch (error) {
    console.error("Error fetching games by game IDs:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};

async fetchAllGames  ()  {
  try {
    let response;
    response = await this.api.get(`/get-all-games`, {
      headers: { "Content-Type": "application/json" },
    });
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching games from database:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};

async fetchtrendingGames  ()  {
  try {
    let response;
    response = await this.api.get(`/gamesLocalsTrending`, {
      headers: { "Content-Type": "application/json" },
    });
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching games from database:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};

async fetchAllGamesByName  (params)  {
  //console.log(params, " fetchAllGamesByName params ");
  try {
    let response;
    response = await this.api.get(`/getgamebyname`, {
      params: params,
      headers: { "Content-Type": "application/json" },
    });
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching games from database:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};

async searchAllGames  (gameName)  {
  try {
    const response = await this.api.get(`/get-all-games-search?gameName=${gameName}`, {
      headers: { "Content-Type": "application/json" },
    });
    //console.log("[DEBUG] API response:", response.data); // Debug API response
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching games from database:", error.response || error);
    throw new Error("Failed to fetch games from the database.");
  }
};


}

export default GameService;